import React from "react"
import { useSelector, useDispatch } from "react-redux"

import {
    StoreType,
    setCcRequirementSelectedRequirementIds,
} from "client/store"
import { CheckButton } from "client/components"

interface SelectAllProps {
    title?: string
}

const InputSelectAll = ({
    title = null,
}: SelectAllProps) => {
    const selectedRequirementIds = useSelector((state: StoreType) => state.ccRequirement.selectedRequirementIds)
    const visibleRequirementIds = useSelector((state: StoreType) => state.ccRequirement.visibleRequirementIds)
    const dispatch = useDispatch()

    const visibleSelected = selectedRequirementIds.filter((id) => visibleRequirementIds.includes(id))
    const selectedAll = visibleRequirementIds.length === visibleSelected.length && visibleRequirementIds.length > 0

    const selectAll = () => {
        if (selectedAll) {
            dispatch(setCcRequirementSelectedRequirementIds([]))
        } else {
            dispatch(setCcRequirementSelectedRequirementIds(visibleRequirementIds))
        }
    }

    return (
        <CheckButton
            title={title}
            checked={selectedAll}
            padding={false}
            margin={false}
            onChange={selectAll}
        />
    )
}
export default InputSelectAll
